import shopQueries from '@apis/queries/shopQueries';
import useCurrency from '@hooks/item/useCurrency';
import { CartResponse } from '@models/cart';
import { useQuery } from '@tanstack/react-query';
import { cartToGtmFormat, pushEcommerceEvent } from '@utils/gtm';
import { useEffect } from 'react';

interface Props {
    cart?: CartResponse;
    shopId: string;
}

function useViewCart({ cart, shopId }:Props) {
    const { data: shop } = useQuery(shopQueries.detail(shopId));
    const currency = useCurrency();

    return useEffect(() => {
        if (shop && cart) {
            pushEcommerceEvent('view_cart', {
                value: cart.cartId,
                currency,
                items: cartToGtmFormat({ cart, shop }),
            });
        }
    }, [shop, cart, currency]);
}

export default useViewCart;
